import PropTypes from "prop-types";
import { useAuthDataContext, permissions as existentPermissions } from "components/auth";

const checkValidPermissions = permissions =>
  permissions.forEach((p, i) => {
    if (!Object.values(existentPermissions).includes(p)) {
      console.error(`Permission [${p}] does not exist.`);
    }
  });

const Restricted = ({ permissions = [], fallback = null, children }) => {
  const { user } = useAuthDataContext();

  checkValidPermissions(permissions);

  return permissions.some(p => user && user.permissions.includes(p)) ? children : fallback;
};

Restricted.propTypes = {
  /**
   * Permitir el acceso solamente a estos permisos
   */
  permissions: PropTypes.array,
  /**
   * Fallback si el usuario no tiene acceso, por defecto null
   */
  fallback: PropTypes.element,
};

export default Restricted;
